import { useAtom } from 'jotai';
import { userInfoAtom } from '@/stores/user';

import { fetchUserInfoApi } from '@/api/user';
import botavatar from '@/assets/images/bot-avatar.png'
export const useUserActions = () => {
    const [userInfo, setUserInfo] = useAtom(userInfoAtom);

    // 核心方法：从后端同步用户信息
    const syncUserProfile = async () => {
        const token = localStorage.getItem(import.meta.env.VITE_TOKEN_KEY);
        if (!token) return; // 没登录就不请求

        try {
            const res = await fetchUserInfoApi(); // 换成你的真实接口
            if (res.code === 200) {
                setUserInfo({
                    name: res.extra.user.nickName
                    ,
                    phone: res.extra.user.phonenumber,
                    avatar: res.extra.user.avatar
                });
            }
            console.log(res);
        } catch (error) {
            console.error("同步用户信息失败:", error);
        }
    };


    return {
        userInfo,
        setUserInfo,
        syncUserProfile,

    };
};